/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { ReleaseManagementPage } from '@/pages/ReleaseManagement/ReleaseManagementPage';

export function ReleaseManagementRoute() {
  return <ReleaseManagementPage />;
}
